@if (shouldDisplayCookieBanner) {
  <div class="cookie-banner card mb-2">
    <div class="alert alert-primary mb-0">
      <h5 i18n="@@CookieBannerHeader">
        Cookie notice
      </h5>
      <div i18n="@@CookieBannerMessage1">
        We use cookies to provide you with an optimal service and to further improve our websites.
      </div>
      <div i18n="@@CookieBannerMessage2">
        Please note that technically necessary cookies must be set to ensure the operation of the websites.
      </div>
      <div class="d-flex justify-content-between justify-content-lg-start flex-column flex-md-row">
        <button class="btn btn-primary w-sm-100 mt-3" i18n="@@CookieBannerConsentButton" (click)="cookieTermConsentClicked()">
          I agree
        </button>
        <button class="btn btn-primary w-sm-100 mt-3 ms-0 ms-lg-3" i18n="@@CookieBannerAdditionalInformationAndSettingsButton" (click)="additionalInformationAndSettingsClicked()">
          Cookie notice and settings
        </button>
      </div>
    </div>
  </div>
}
